<app-side-dialog headerGlyph="filter" [headerText]="title" saveText="Apply"
                 [body]="body" (save)="onSubmit()" [validationFn]="isValid.bind(this)"></app-side-dialog>

<ng-template #body>

    <app-container [body]="filterContent">

    </app-container>

    <ng-template #filterContent>
        <div class="outer-wrapper">
            <app-search-field class="filter-search" id="filter-search" [searchTerm]="searchTerm"
                              (doSearch)="doSearch($event)"></app-search-field>
            <div id="wrapper">
                <cdk-virtual-scroll-viewport [itemSize]="44">
                    <fd-checkbox
                            id="select-all"
                            [(ngModel)]="isAllChecked"
                            (change)="onSelectAll($event)"
                            class="bold"
                            label="{{searchTerm ? 'Select All Search Results' : 'Select All'}}"
                    >
                    </fd-checkbox>
                    <div *cdkVirtualFor="let choice of displayedValues | filterBy: searchTerm: ['value'] | sortBy:true:'value'; let i=index">
                        <fd-checkbox
                                class="filter-item"
                                [name]="choice.value"
                                [(ngModel)]="choice.checked"
                                [label]="choice.value !== '' ? choice.value : '(Blank)'"
                                (change)="onCheckboxChange()"
                        >
                        </fd-checkbox>

                    </div>
                </cdk-virtual-scroll-viewport>
            </div>
        </div>
    </ng-template>

</ng-template>
